import React from 'react';
import { Box, Loader, Text } from '@mantine/core';
import { WorkflowStepsViewer } from '../../workflows/WorkflowStepsViewer';

export interface EntityDetailWorkflowStepsTabProps {
    workflow: any | null;
}

export const EntityDetailWorkflowStepsTab: React.FC<EntityDetailWorkflowStepsTabProps> = ({ workflow }) => {
    return (
        <Box>
            {workflow ? (
                <WorkflowStepsViewer workflow={workflow} />
            ) : (
                <Box p="xs">
                    <Loader size={24} />
                    <Text size="sm" c="dimmed">
                        Loading workflow steps...
                    </Text>
                </Box>
            )}
        </Box>
    );
};

